import { render } from "./UCInputIncrement.vue?vue&type=template&id=6071fbfe&scoped=true"
import script from "./UCInputIncrement.vue?vue&type=script&lang=js"
export * from "./UCInputIncrement.vue?vue&type=script&lang=js"

import "./UCInputIncrement.vue?vue&type=style&index=0&id=6071fbfe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6071fbfe"]])

export default __exports__